import {
    DeleteOutlined,
    FormOutlined,
    PlusOutlined
} from "@ant-design/icons";
import { ColorPicker } from "@src/page/DynamicChartManagement/add";
import { Button, Col, Input, Modal, Row, Table } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import API from "../../api/backend/machineManagement";
import { COMMON_CONSTANT, KEY, lang } from "../../constants/common.const";
import rolesConst from "../../routers/roles/roles.const";
export const ButtonModalClassification = ({ callback, fullButton = false }) => {
    const { roles } = useSelector((state) => state.auth);
    const isAdmin = [
      rolesConst.OFFICE_ADMIN,
      rolesConst.HEAD_OFFICE_ADMIN,
    ].includes(roles);
  
    const isPC = useMediaQuery({
      query: KEY.LAPTOP_WIDTH,
    });
  
    const [visible, setVisible] = useState(false);
    const [classification, setClassification] = useState([]);
    const classRef = useRef(null);
  
    const getClassification = async () => {
      try {
        const res = await API.getClassification();
        setClassification(res.data);
      } catch (e) {
      }
    };
  
    const updateClassification = async () => {
      try {
        await API.updateClassification(classification);
        Modal.success({
          centered: true,
          title: <span style={{ fontWeight: "bold" }}>{lang.SUCCESS}</span>,
          content: COMMON_CONSTANT.BOM_C002,
          okText: lang.OK,
          onOk: callback,
        });
      } catch (e) {
      }
    };
    const setModalOn = () => {
      getClassification();
      setVisible(true);
    };
  
    const setModalOff = () => {
      setVisible(false);
    };
  
    const handleOK = async () => {
      await updateClassification();
      setVisible(false);
    };
  
    const column = [
      {
        title: "色",
        dataIndex: "color",
        key: "color",
        width: "10%",
        render: (color, record, index) => {
          return (
            <ColorPicker
              color={color}
              onChange={(color) => {
                const newClassification = [...classification];
                newClassification[index].color = color;
                setClassification(newClassification);
              }}
            />
          );
        },
      },
      {
        title: "区分",
        dataIndex: "classification",
        key: "classification",
        render: (text, record, index) => {
          return (
            <Input
              ref={classRef}
              value={text}
              onChange={(e) => {
                const newClassification = [...classification];
                newClassification[index].classification = e.target.value;
                setClassification(newClassification);
              }}
            />
          );
        },
      },
      {
        title: "",
        dataIndex: "id",
        key: "id",
        width: "70px",
        render: (id, record, index) => {
          return (
            <Button
              disabled={!record.canDelete}
              className="btnDelete"
              onClick={() => {
                const newClassification = [...classification];
                newClassification.splice(index, 1);
                setClassification(newClassification);
              }}
            >
              <DeleteOutlined />
            </Button>
          );
        },
      },
    ];
  
    useEffect(() => {
      if (
        isEmpty(classification) ||
        !classRef ||
        (classRef.current &&
          classRef.current.props &&
          classRef.current.props.value)
      )
        return;
      if (classRef.current) {
        classRef.current.focus();
      }
    }, [classification]);
  
    if (!isAdmin) return <></>;
  
    return (
      <>
        {!fullButton ? (
          <Button className="blue p0" onClick={setModalOn} type="link">
            <FormOutlined />
          </Button>
        ) : (
          <Button
            onClick={setModalOn}
            className="buttonPC button--info wAuto ml12"
          >
            <FormOutlined />
            {lang.MAINTAINCE_PIC}
          </Button>
        )}
        <Modal
          centered
          width={isPC ? "60%" : "100%"}
          closeIcon={<></>}
          className=""
          title={null}
          visible={visible}
          onCancel={setModalOff}
          footer={
            <Row>
              <Col span={4} style={{ textAlign: "left" }}>
                <Button
                  style={{
                    background: "#f7f9fc",
                    width: "auto",
                    minWidth: "auto",
                  }}
                  className="pr10 pl10"
                  onClick={() => {
                    const newClassification = [...classification];
                    newClassification.push({
                      color: "#ffffff",
                      name: "",
                      canDelete: true,
                    });
                    setClassification(newClassification);
                  }}
                  icon={<PlusOutlined />}
                />
              </Col>
              <Col span={20} style={{ textAlign: "right" }}>
                <Button
                  key={1}
                  className="buttonPC button--info wAuto"
                  onClick={() => {
                    handleOK();
                  }}
                >
                  {lang.OK}
                </Button>
                <Button
                  onClick={setModalOff}
                  className="buttonPC --todo-- wAuto  button--outline"
                >
                  {lang.CANCEL}
                </Button>
              </Col>
            </Row>
          }
        >
          <Table
            className="tableAddMachine"
            scroll={{ y: 300 }}
            rowKey="ItemOrder"
            dataSource={classification}
            columns={column}
            pagination={false}
            bordered
          />
        </Modal>
      </>
    );
  };
  